module.exports = __webpack_public_path__ + "img/timer.890e9a87.svg";